export const filterInsights = (
  insights: Array<{ category: string; is_archived: boolean }>,
  category: string,
  isActive: boolean,
) => {
  if (category === "all") {
    return insights.filter((insight) => insight.is_archived !== isActive);
  }

  return insights.filter(
    (insight) =>
      insight.category === category && insight.is_archived !== isActive,
  );
};
